import api from '../services/axios.service';
import { constructQueryParams } from '../utils/utils';

export async function fetchTransformsForConnectors(page_size = 1000) {
    return api.get(`transforms?page_size=${page_size}`);
}

export async function fetchTransform(id) {
    const response = await api.get(`transforms/${id}`);

    return response?.result?.[0];
}

export async function fetchTransforms({ page_size, page_number, partial_name }) {
    const queryParams = constructQueryParams({ page: page_number, page_size, partial_name });

    return api.get(`transforms/details?${queryParams}`);
}

export async function fetchTransformConfigs() {
    return api.get(`transforms/configs`);
}

export async function editTransform(data) {
    return api.put(`transforms`, data);
}

export async function createTransform(data) {
    return api.post(`transforms`, data);
}

export async function deleteTransform(id) {
    return api.delete(`transforms?id=${id}`);
}

export async function transformImplementationDetails(id) {
    return api.get(`transforms/${id}/implementation_details`);
}

export async function editImplementationDetails(id, data) {
    return api.put(`transforms/${id}/implementation_details`, data);
}

export async function topicsForPattern(topicPattern, replacementPattern) {
    var topicPatternEsc = encodeURIComponent(topicPattern);
    var replacementPatternEsc = encodeURIComponent(replacementPattern);
    return api.get(`transforms/topics-for-pattern/${topicPatternEsc}/${replacementPatternEsc}`);
}

export async function runUnitTests(id, versionId) {
    return api.put(`transforms/${id}/run-unit-tests/${versionId}`);
}

export async function deployPreview(id, versionId) {
    return api.put(`transforms/${id}/deploy-job-preview/${versionId}`);
}

export async function deployLive(id, versionId) {
    return api.put(`transforms/${id}/deploy-job-live/${versionId}`);
}
